import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EditableTitle from '../../components/widgets/EditableTitle';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { PROMPT_MAX_LENGTH } from '../constants';
import css from './PromptTitleEditor.css';

const PromptTitleEditor = ({ initialTitle, onSave, onDone, maxLength = PROMPT_MAX_LENGTH, allowEmpty = false }) => {
    const [title, setTitle] = useState(initialTitle);
    const [saving, setSaving] = useState(false);

    const finish = async () => {
        const value = title.trim();
        if ((!value && !allowEmpty) || value === initialTitle) {
            onDone();
            return;
        }
        if (saving) return;
        setSaving(true);
        const saved = await onSave(value)
            .then(() => true)
            .catch(() => false);
        setSaving(false);
        if (saved) onDone();
    };

    return (
        <div className={css.editRow}>
            <EditableTitle
                value={title}
                onTextChanged={setTitle}
                onTextChangeComplete={finish}
                containerClass={css.titleContainer}
                selectOnFocus
                maxLength={maxLength}
            />
            {saving && <Icon name="loader" size={IconSizes.X_SMALL} className={css.savingSpinner} />}
        </div>
    );
};

PromptTitleEditor.propTypes = {
    initialTitle: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
    maxLength: PropTypes.number,
    allowEmpty: PropTypes.bool,
};

export default PromptTitleEditor;
